<template>
  <div>
    <slot
      v-if="propriedades.column.type === 'personalizada'"
      name="celula-personalizada"
    >
      <span
        v-if="propriedades.column.showActive"
        :class="propriedades.column.editable && permissaoUpdate ? 'editable-column' : ''"
        @click="editarItemPorColuna(propriedades.column.editable, propriedades.row)"
      >
        {{ propriedades.formattedRow[propriedades.column.field] }}
        <span
          v-b-tooltip.hover
          :class="['ativo-badge', {'badge badge-success':propriedades.row.ativo, 'badge badge-danger': !propriedades.row.ativo}]"
          :title="propriedades.row.ativo ? 'Ativo no sistema' : 'Inativo no sistema'"
        >
          {{ propriedades.row.ativo ? 'Ativo' : 'Inativo' }}
        </span>
        <span
          v-if="(propriedades.row.hasUsuarioInativoVinculado || propriedades.row.erroIntegracaoOmie || propriedades.row.semEmailNfBoletos)"
          v-b-tooltip.hover.html
          :title="tooltipBadgeInfoText"
          :class="['ativo-badge', {'badge badge-info':(propriedades.row.hasUsuarioInativoVinculado || propriedades.row.erroIntegracaoOmie || propriedades.row.semEmailNfBoletos)}]"
        >
          Atenção
        </span>
        <slot
          name="etiquetas-personalizadas"
        />
      </span>
    </slot>
    <span
      v-else-if="propriedades.column.type === 'Boolean'"
      :class="propriedades.column.editable && permissaoUpdate ? 'editable-column' : ''"
      @click="editarItemPorColuna(propriedades.column.editable, propriedades.row)"
    >
      {{ propriedades.formattedRow[propriedades.column.field] ? 'Sim' : 'Não' }}
    </span>
    <span
      v-else-if="propriedades.column.type === 'LargeText'"
      :class="propriedades.column.editable && permissaoUpdate ? 'editable-column' : ''"
      style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 600px;display: block;"
      @click="editarItemPorColuna(propriedades.column.editable, propriedades.row)"
    >
      <span>
        {{ propriedades.formattedRow[propriedades.column.field] }}
      </span>
    </span>
  </div>
</template>

<style scoped>
.ativo-badge{
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}
</style>

<script>

export default {
  props: {
    propriedades: {
      type: Object,
      default: null,
    },
    permissaoUpdate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tooltipBadgeInfoText() {
      const mensagens = []

      if (this.propriedades.row.hasUsuarioInativoVinculado) {
        mensagens.push('Há usuário inativo vinculado')
      }

      if (this.propriedades.row.erroIntegracaoOmie) {
        mensagens.push('Erro de integração com Omie')
      }

      if (this.propriedades.row.semEmailNfBoletos) {
        mensagens.push('Falta de e-mail para NF/boletos')
      }

      return mensagens.join('<br>')
    },
  },
  methods: {
    editarItemPorColuna(editable, row) {
      this.$emit('editar-item-coluna', { editable, row })
    },
  },
}
</script>
